var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRestaurant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Base"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 4.15906C25.1046 4.15906 26 5.05449 26 6.15906V11.8514C26 17.4723 21.5933 22.1591 16 22.1591C10.4067 22.1591 6 17.4723 6 11.8514L6 6.15906C6 5.05449 6.89543 4.15906 8 4.15906C9.10457 4.15906 10 5.05449 10 6.15906L10 11.8514C10 15.4068 12.7568 18.1591 16 18.1591C19.2432 18.1591 22 15.4068 22 11.8514V6.15906C22 5.05449 22.8954 4.15906 24 4.15906Z",
    fill: "#15D4B6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 4.15906C17.1046 4.15906 18 5.05449 18 6.15906L18 42.1591C18 43.2636 17.1046 44.1591 16 44.1591C14.8954 44.1591 14 43.2636 14 42.1591L14 6.15906C14 5.05449 14.8954 4.15906 16 4.15906Z",
    fill: "#15D4B6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 9.15778V26.1591H35.9999C37.1043 26.1591 38 25.2634 38 24.1587L38 20.0472C38 15.4257 35.7384 11.2723 32 9.15778ZM32 30.1591H35.9999C39.3137 30.1591 42 27.4722 42 24.1587L42 20.0473C42 13.2562 38.1312 6.86826 31.4964 4.55772C31.2277 4.46414 31.0134 4.39072 30.8656 4.34042L30.6949 4.28264L30.6496 4.26742L30.634 4.26222C30.0241 4.05892 29.3521 4.16067 28.8306 4.53657C28.309 4.91248 28 5.51617 28 6.15906L28 42.159C28 43.2636 28.8954 44.159 30 44.159C31.1046 44.159 32 43.2636 32 42.159L32 30.1591Z",
    fill: "#15D4B6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRestaurant);
export default __webpack_public_path__ + "static/media/iconRestaurant.b481e1652c24b5b8ea10f6f63c0f60e4.svg";
export { ForwardRef as ReactComponent };